export const DEMO_HOSTNAME = "novccmsdv.dev.techunicornpreprod.com";

export function isDemoEnvironment(): boolean {
  return window.location.hostname === DEMO_HOSTNAME;
}
